/**
 * Button labels used in different button type
 * @enum {string}
 */
export const ButtonLabels = {
  SHOW_ALL: 'Show all',
  SHOW_FEWER: 'Show fewer',
};
